module.exports = __webpack_public_path__ + "static/media/P4trans1.9911440f.png";